export default {
  transaction: {
    title: 'Transaksyon',
    select: 'Pumili',
    all: 'Lahat',
    loading: 'Naglo-load...',
    noMoreData: 'Wala nang datos',
    mockSuccess: 'Mock na Tagumpay',
    mockFail: 'Mock na Pagkabigo',
    mockSuccessDone: 'Tapos na ang mock na tagumpay',
    mockFailDone: 'Tapos na ang mock na pagkabigo',
    mockFailed: 'Nabigo ang mock',
    today: 'Ngayon',
    yesterday: 'Kahapon',
    last3Days: 'Huling 3 araw',
    last7Days: 'Huling 7 araw',
    last15Days: 'Huling 15 araw',
    last30Days: 'Huling 30 araw',
    allTypes: 'Lahat ng uri',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    withdrawalRefund: 'Refund ng withdrawal',
    bet: 'Taya',
    win: 'Panalo',
    manualAdd: 'Manu-manong dagdag',
    manualSubtract: 'Manu-manong bawas',
    commission: 'Komisyon',
    bonus: 'Bonus',
    vipUpgradeReward: 'Gantimpala sa pag-upgrade ng VIP',
    vipSalary: 'Sahod ng VIP',
    gameOutPrincipal: 'Labas sa laro - Puhunan',
    gameOutBonus: 'Labas sa laro - Bonus',
    bonusTransferOut: 'Paglipat ng bonus palabas',
    allStats: 'Lahat ng katayuan',
    underReview: 'Sinusuri',
    pendingPayout: 'Naghihintay ng bayad',
    successful: 'Matagumpay',
    failed: 'Nabigo',
    cancelled: 'Kinansela',
    processing: 'Pinoproseso',
  },
};
